import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { finalize, map, of, Subject, switchMap, takeUntil } from 'rxjs';
import { FileService } from 'src/app/services/api/file.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-dialog-select-service',
  templateUrl: './dialog-select-service.component.html',
  styleUrls: ['./dialog-select-service.component.css']
})
export class DialogSelectServiceComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  private destroy$ = new Subject<void>();

  servicesDataSource = new MatTableDataSource<any>();
  loadingTable: boolean = true;
  selectedService: any | null = null;

  columnsTable: string[] = [
    'select',
    'activityDayNumber',
    'nombreServicio',
    'tipoServicio',
    'nombreProveedor'
  ];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private readonly fileService: FileService,
    private readonly cdRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<DialogSelectServiceComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      itineraryId?: string; // Si existe itineraryId, quiere decir que lo llama la tabla de incidencias operativas, búsqueda de servicios por itinerario
      availableServices: any[];
      associatedServiceIds?: string[]; // Desabilita servicios con Incidencias ya asociadas
      activityDayNumber?: number;
      activityDayName?: string;
    }
  ) {
    console.log({
      DialogSelectServiceComponentData: this.data
    });
  }

  ngOnInit(): void {
    this.loadServices();
  }

  ngAfterViewInit(): void {
    this.servicesDataSource.paginator = this.paginator;
    this.servicesDataSource.sort = this.sort;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadServices(): void {
    if (
      (this.data.availableServices == null ||
        this.data.availableServices?.length === 0) &&
      this.data.itineraryId != null
    ) {
      this.fileService
        .getServicesByFileID(
          this.data.itineraryId,
          'id, nombreServicio, tipoServicio, day, providerId, objProvider.nombre'
        )
        .pipe(
          switchMap(({ getServicesByFileID }) => {
            if (getServicesByFileID.length === 0) {
              return of([] as any[]);
            }

            const providerIds = Array.from(
              new Set(
                getServicesByFileID.map((service: any) => service.providerId)
              )
            ) as string[];

            return this.fetchProvidersByIds(providerIds).pipe(
              map((providers: any[]) => {
                const providerMap = new Map(
                  providers.map((provider) => [provider.id, provider.nombre])
                );
                return getServicesByFileID.map((service: any) => ({
                  ...service,
                  activityDayNumber: service.day || '-',
                  nombreServicio: service.nombreServicio || 'N/A',
                  tipoServicio: service.tipoServicio || 'N/A',
                  nombreProveedor:
                    providerMap.get(service.providerId) ||
                    service.objProvider?.nombre ||
                    '-'
                }));
              })
            );
          }),
          finalize(() => {
            this.loadingTable = false;
            this.cdRef.detectChanges();
          }),
          takeUntil(this.destroy$)
        )
        .subscribe({
          next: (fileServices: any[]) => {
            this.servicesDataSource.data = fileServices.sort(
              (a: any, b: any) => {
                const dayA =
                  a.activityDayNumber === '-'
                    ? Infinity
                    : Number(a.activityDayNumber);
                const dayB =
                  b.activityDayNumber === '-'
                    ? Infinity
                    : Number(b.activityDayNumber);
                if (dayA !== dayB) {
                  return dayA - dayB;
                }
                return a.nombreServicio.localeCompare(b.nombreServicio);
              }
            );

            this.servicesDataSource.paginator = this.paginator;
            this.servicesDataSource.sort = this.sort;
          },
          error: (error) => {
            console.error('Error fetching services by file ID:', error);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'No se pudieron cargar los servicios, por favor vuelva a intentar. Si persiste, vuelva a iniciar sesión.'
            });
          }
        });
      return;
    }

    this.servicesDataSource.data = (this.data.availableServices || [])
      .map((service) => {
        const mappedService = {
          ...service,
          nombreServicio: service.nombreServicio || 'N/A',
          tipoServicio: service.tipoServicio || 'N/A',
          nombreProveedor: service.objProvider?.nombre || '-'
        };

        if (
          this.data.activityDayNumber != null &&
          this.data.activityDayNumber != null
        ) {
          mappedService.activityDayNumber = this.data.activityDayNumber;
          mappedService.activityDayName = this.data.activityDayName;
        }

        return mappedService;
      })
      .sort((a: any, b: any) => {
        const dayA =
          a.activityDayNumber === '-' ? Infinity : Number(a.activityDayNumber);
        const dayB =
          b.activityDayNumber === '-' ? Infinity : Number(b.activityDayNumber);
        if (dayA !== dayB) {
          return dayA - dayB;
        }
        return a.nombreServicio.localeCompare(b.nombreServicio);
      });
    this.loadingTable = false;
  }

  fetchProvidersByIds(providerIds: string[]) {
    return this.fileService.getProvidersByIds(providerIds, 'id, nombre').pipe(
      map((response: any) => {
        return response.getProvidersByIds || [];
      })
    );
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.servicesDataSource.filter = filterValue.trim().toLowerCase();
  }

  saveSelectedService(): void {
    console.log({
      selectedService: this.selectedService
    });
    if (!this.selectedService) {
      return;
    }
    console.log('Servicio seleccionado:', this.selectedService);
    const serviceProviderName =
      this.selectedService.nombreProveedor ||
      this.selectedService.objProvider?.nombre ||
      '-';

    console.log({
      serviceProviderName
    });

    const appendService = {
      serviceId: this.selectedService.id,
      serviceName: this.selectedService.nombreServicio,
      serviceType: this.selectedService.tipoServicio,
      serviceProviderName
    };
    this.dialogRef.close({
      event: 'op_incident_append_service',
      op_incident_append_service: appendService
    });
  }

  close(): void {
    this.dialogRef.close({ event: 'nothing' });
  }
}
